import React, { useState, useEffect } from "react";
import axios from "axios";
import {
    Table,
    Button,
    Spinner,
    Dropdown,
    DropdownButton,
} from "react-bootstrap";
import config from "../../../config";
import PaginationComponent from "./PaginationComponent";

const UnlistedLeadsList = ({ onEdit }) => {
    const [leads, setLeads] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: 10,
        totalPages: 1,
    });

    const tokenConfig = {
        headers: { Authorization: `Token ${sessionStorage.getItem("tokenKey")}` },
    };

    const fetchUnlistedLeads = () => {
        setLoading(true);
        axios
            .get(`${config.service}/leads_v2/leads/`, {
                ...tokenConfig,
            })
            .then(({ data }) => {
                // Handle both paginated and non-paginated responses
                const results = Array.isArray(data) ? data : (data.results || []);
                const count = Array.isArray(data) ? data.length : (data.count || 0);

                setLeads(results);
                setPagination((prev) => ({
                    ...prev,
                    totalPages: Math.ceil(results.length / prev.pageSize),
                }));
            })
            .catch((err) => {
                console.error("Error fetching unlisted leads:", err);
            })
            .finally(() => setLoading(false));
    };

    useEffect(fetchUnlistedLeads, []);

    // Frontend pagination: slice the leads array
    const indexOfLastLead = pagination.page * pagination.pageSize;
    const indexOfFirstLead = indexOfLastLead - pagination.pageSize;
    const currentLeads = leads.slice(indexOfFirstLead, indexOfLastLead);

    return (
        <>
            {loading ? (
                <div className="text-center py-5">
                    <Spinner animation="border" variant="primary" />
                    <p>Loading unlisted leads...</p>
                </div>
            ) : (
                <>
                    <Table striped bordered hover responsive>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Agent Name</th>
                                <th>Venue Name</th>
                                <th>Location</th>
                                <th>Customer Name</th>
                                <th>Contact Number</th>
                                <th>Event Type</th>
                                <th>Event Date</th>
                                <th>Remarks</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentLeads.length === 0 ? (
                                <tr>
                                    <td colSpan="9" className="text-center">
                                        No unlisted leads found.
                                    </td>
                                </tr>
                            ) : (
                                currentLeads.map((lead) => (
                                    <tr key={lead.id}>
                                        <td>{lead.id}</td>
                                        <td>{lead.kae?.name?.split(" (")[0] || "N/A"}</td>
                                        <td>{lead.unlisted_venue_name || "N/A"}</td>
                                        <td>{lead.unlisted_venue_location || "N/A"}</td>
                                        <td>{lead.customer_name || "N/A"}</td>
                                        <td>{lead.contact_number || "N/A"}</td>
                                        <td>{lead.primary_event_type || "N/A"}</td>
                                        <td>{lead.primary_event_date || "N/A"}</td>
                                        <td>{lead.remarks || "N/A"}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>


                    </Table>
                    {leads.length > 0 && pagination.totalPages > 1 && (
                        <PaginationComponent
                            currentPage={pagination.page}
                            totalPages={pagination.totalPages}
                            onPageChange={(page) =>
                                setPagination((prev) => ({ ...prev, page }))
                            }
                        />
                    )}
                </>
            )}
        </>
    );
};

export default UnlistedLeadsList;
